import { Component, OnInit } from '@angular/core';
import { IAuthenticationService, LogService } from '@pershing/pershing-core';

@Component({
    selector: 'nxp-login',
    templateUrl: 'login.component.html'
})

export class LoginComponent implements OnInit {
    errorMessage: string;
    constructor(private authenticationService: IAuthenticationService, private logger: LogService) { }

    ngOnInit() {}

    login(userIdElement: HTMLInputElement, passwordElement: HTMLInputElement): void {
        this.authenticationService.authenticate(userIdElement.value.toUpperCase(), passwordElement.value)
            .then(response => {
                if (response === 0) {
                    this.errorMessage = null;
                } else if (response === 1) {
                    this.errorMessage = 'Invalid Password';
                } else if (response === 2) {
                    this.errorMessage = 'Invalid User ID';
                } else {
                    this.errorMessage = 'System error occurred. Please try again later.';
                }
            })
            .catch(this.handleError);
    }

    logout(): void {
        this.authenticationService.logout();
    }

    isLoggedIn(): boolean {
        return this.authenticationService.isLoggedIn();
    }

    private handleError(error: any): void {
        this.logger.error('Error: ', error);
    }
}
